import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges Tailwind class names, resolving any conflicts.
 *
 * @param inputs - An array of class names to merge.
 * @returns A string of merged and optimized class names.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Formatte une date en YYYY-MM-DD sans problème de timezone.
 * Utilise les méthodes locales pour éviter les conversions UTC indésirables.
 *
 * @param date - La date à formater
 * @returns Une string au format YYYY-MM-DD
 */
export function formatDateToString(date: Date): string {
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
}

/**
 * Formatte une date UTC en YYYY-MM-DD en utilisant les méthodes UTC.
 * À utiliser pour les dates reçues du serveur (format ISO UTC).
 *
 * @param utcDate - La date UTC à formater
 * @returns Une string au format YYYY-MM-DD
 */
export function formatUTCDateToString(utcDate: Date): string {
  return `${utcDate.getUTCFullYear()}-${(utcDate.getUTCMonth() + 1).toString().padStart(2, "0")}-${utcDate.getUTCDate().toString().padStart(2, "0")}`;
}
